// Shared formatters for the AVM result UI.

const USD = new Intl.NumberFormat("en-US", {
  style: "currency",
  currency: "USD",
  maximumFractionDigits: 0,
});

export function money(value) {
  if (value === null || value === undefined || Number.isNaN(Number(value))) return "—";
  return USD.format(Number(value));
}

export function shortDate(iso) {
  if (!iso) return "";
  // The backend emits date-only strings (YYYY-MM-DD); new Date("YYYY-MM-DD")
  // parses as UTC midnight, which renders as the PRIOR day (and possibly prior
  // month) west of UTC. Build a LOCAL date from the parts so a first-of-month
  // sold date isn't shown as the previous month.
  const parts = /^(\d{4})-(\d{2})-(\d{2})$/.exec(iso);
  const d = parts
    ? new Date(Number(parts[1]), Number(parts[2]) - 1, Number(parts[3]))
    : new Date(iso);
  if (Number.isNaN(d.getTime())) return "";
  return d.toLocaleDateString("en-US", { month: "short", year: "numeric" });
}

// Full day-precision date for record tables (deeds/mortgages/valuation history),
// where two rows can fall in the same month. Same local-parse guard as shortDate.
export function longDate(iso) {
  if (!iso) return "";
  const parts = /^(\d{4})-(\d{2})-(\d{2})$/.exec(iso);
  const d = parts
    ? new Date(Number(parts[1]), Number(parts[2]) - 1, Number(parts[3]))
    : new Date(iso);
  if (Number.isNaN(d.getTime())) return "";
  return d.toLocaleDateString("en-US", { month: "short", day: "numeric", year: "numeric" });
}
